import React from "react";
import { Box, Typography } from "@bca/ui-library";
import getShowCountVehiclesNumber from "./getShowCountVehiclesNumber";

interface ShowVehiclesCountProps {
  totalResultCount: number;
  pageSize: number;
  isLastPage: boolean;
}

const ShowVehiclesCount: React.FunctionComponent<ShowVehiclesCountProps> = ({
  totalResultCount,
  pageSize,
  isLastPage,
}) => {
  return (
    <Box
      alignSelf={{
        mobile: "center",
        desktop: "flex-start",
      }}
    >
      <Typography color="grey-blue" fontSize="16px">
        Showing{" "}
        <strong>
          {getShowCountVehiclesNumber(pageSize, totalResultCount, isLastPage)}
        </strong>{" "}
        of <strong>{totalResultCount}</strong> vehicles
      </Typography>
    </Box>
  );
};

export default ShowVehiclesCount;
